const SET_PATH_MAPPING = 'breadcrumb/SET_PATH_MAPPING';
const DELETE_PATH_MAPPING = 'breadcrumb/DELETE_PATH_MAPPING';

export default {
  SET_PATH_MAPPING,
  DELETE_PATH_MAPPING
};